import { PayloadError } from "../PayloadError";
import { ITransportador } from "../Transportador";
import { LogTipos } from "../Utilidades";

export class ConsolaTransportador implements ITransportador {
    escribir(payload: PayloadError, tipo: LogTipos): void {
        if (tipo === LogTipos.DEBUG) {
            console.log(`Debug: ${payload.mensaje}\nStack: ${payload.stack}`);
        }

        if (tipo === LogTipos.ERROR) {
            console.error(`Error: ${payload.mensaje}\nStack: ${payload.stack}`);
        }

        if (tipo === LogTipos.INFO) {
            console.log(`Info: ${payload.mensaje}\nStack: ${payload.stack}`);
        }

        if (tipo === LogTipos.WARNING) {
            console.warn(`Warning: ${payload.mensaje}\nStack: ${payload.stack}`);
        }
    }

}
